export const isGiftingPages = (path) => path.includes('redeem');

export const isSignUpPage = (path) => path.includes('signup-account');

export const isSignUpPlans = (path) => path.includes('signup-plans');

//Necessary to prevent XSS attacks, e.g. with javascript:eval( starting url
//See NATCOM-1285
// if url contains protocol, only escape the rest of the url and attach the protocol again after escaping
// escape specific characters because encodeURIComponent breaks the url as it escapes forward slashes and
//    encodeURI does not escape colons (which do not prevent javascript injection e.g. the above example)
export const sanitizePath = (path) => {
  const pathIsNotSecure = /^http\:/.test(path);
  if (pathIsNotSecure) return false;

  const specialCharacters = /[<>"':;()+%]/g;

  const pathContainsProtocol = /^https\:/.test(path);
  if (pathContainsProtocol) {
    const splitPath = path.split(':');
    return (
      splitPath[0] +
      ':' +
      splitPath
        .slice(1)
        .join(':')
        .replace(specialCharacters, (charToEscape) => {
          return '%' + charToEscape.charCodeAt(0).toString(16);
        })
    );
  }
  return path.replace(specialCharacters, (charToEscape) => {
    return '%' + charToEscape.charCodeAt(0).toString(16);
  });
};

// Checks if URL starts with HTTPS
export const isSecuredPath = (path) => {
  const isSecured = /^https\:/.test(path);
  return isSecured ? true : false;
};

export const setLocation = (path, type = 'replace') => {
  const sanitizedPath = sanitizePath(path);
  if (sanitizedPath === false) {
    //This is not a real path - just is a path to take user to NotFoundContainer.js
    return window.location.replace('/account/notfound');
  }

  switch (type) {
    case 'replace':
      window.location.replace(sanitizedPath);
      break;
    case 'assign':
      window.location.assign(sanitizedPath);
      break;
    case 'href':
      redirectToExternal(sanitizedPath);
      break;
  }
};

export const redirectToExternal = (url, searchParams) => {
  let finalUrl = url;
  if (searchParams) {
    const searchParamsString = searchParams.toString();
    if (searchParamsString.length > 0) {
      finalUrl += `?${searchParamsString}`;
    }
  }
  window.location.href = finalUrl;
};

/** URL Encode a list of search parameters, so they're correctly formated
 * @param {{ [key]: value }} search_params - Object of search parameters to be used.
 * The key is used as the search parameter name, and the value as the search parameter value.
 * @example
 * encodeSearchParams({ param_name: 'param_value', return_to: '/account' })
 * // Returns "param_name=param_value&return_to=%2Faccount"
 **/
export const encodeSearchParams = (parameters) => {
  const searchParamObj = new URLSearchParams();
  Object.entries(parameters).forEach(([name, value]) => {
    searchParamObj.set(name, value);
  });
  return searchParamObj.toString();
};
